module.exports = __webpack_public_path__ + "static/media/third.fb3a2498.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutme/slider/third.png
// module id = 536
// module chunks = 0